import { Grid, Typography } from "@mui/material";
import React, { CSSProperties, FunctionComponent } from "react";
import SmartPredictSvg from "SvgIcons/SmartPredictSvg";

interface AcxStatusStickerProps {
    title?: string;
    customRootStyles?: CSSProperties;
}

type Props = AcxStatusStickerProps;

const AcxStatusSticker: FunctionComponent<Props> = ({
    title,
    customRootStyles,
}) => {
    return (
        <Grid
            container
            alignContent="center"
            alignItems="center"
            sx={{ textAlign: "center", borderRadius: "2px" }}
            style={customRootStyles}
        >
            <SmartPredictSvg />

            <Typography
                variant="caption"
                sx={(theme) => ({
                    marginInline: theme.spacing(1),
                    fontWeight: "bold",
                    color: theme.palette.secondary.main,
                })}
            >
                {title ?? "Smart Predict"}
            </Typography>
        </Grid>
    );
};

export default AcxStatusSticker;
